import { createRouter, createWebHistory } from 'vue-router'
import { SessionUtil } from '@/utils/sessionUtil.js'
import * as types from '@/store/mutation-types'
import store from '@/store'
// import mitt from 'mitt'

const requireRoute = require.context('./routes', false, /\.js$/) // Get js files inside routes folder
const routes = []
// const emitter = mitt()

requireRoute.keys().forEach(fileName => {
    // Avoid the index.js file
    if (fileName === './index.js') {
        return;
    }

    const route = requireRoute(fileName).default
    routes.push(...route)
})

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    // mode: 'history',
    routes: [...routes]
})

router.beforeEach(function(to, from, next) {
    console.log(from.path + '->' + to.path);

    let procYn = true;
    if ( store.getters.alertDialog ) {
        store.commit(types.ALERT_DIALOG, false);
        procYn = false;
    }

    if ( store.getters.confirmDialog ) {
        store.commit(types.CONFIRM_DIALOG, false);
        procYn = false;
    }
    
    if ( procYn )
    {
        if ( to.name !== 'Login' &&
             to.name !== 'guarTelCert' &&
             to.name !== 'guarTermAgre' &&
             to.name !== 'guarInfo' &&
             to.name !== 'prntInfo' &&
             to.name !== 'sposInfo' && 
             to.name !== 'pwSet01'  && 
             to.name !== 'pwSet02'  && 
             to.name.indexOf('sample') == -1 )
        {
            const emitter = store.getters.emitter;

            if ( to.name === 'chldMain' && ( from.params['scrnDiv'] != to.params['scrnDiv'] ))
            {
                store.commit(types.SCRN_DIV, to.params.scrnDiv);
                emitter.emit('onChangeSlide'   , to.params.scrnDiv);
                emitter.emit('onChangeMainMenu', true);
            }
            else
            {
                emitter.emit('onChangeMainMenu', false);
            }

            // 페이지 새로고침 시 Vuex roleList 복원
            if (store.getters.roleList.length === 0) {
                const savedRoleList = SessionUtil.getUserRoleList();
                if (Array.isArray(savedRoleList) && savedRoleList.length > 0) {
                    store.commit(types.ROLE_LIST, savedRoleList);
                }
            }

            const tokn = SessionUtil.getToken();
            if ( tokn ) {
                next();
            } else {
                // fix
                // 토큰이 없을경우 로그인 화면으로 감
                // next({ name: 'Login' })
                next();
            }
        } else {
            next();
        }
    }
    else
    {
        next(false);
    }
});


export default router
